import { render, staticRenderFns } from "./unsleep.vue?vue&type=template&id=2395f9be&scoped=true"
import script from "./unsleep.vue?vue&type=script&lang=js"
export * from "./unsleep.vue?vue&type=script&lang=js"
import style0 from "./unsleep.vue?vue&type=style&index=0&id=2395f9be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2395f9be",
  null
  
)

export default component.exports